// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobAspects_title__NWhVl {
  padding: 16px 24px;
  font-size: 20px;
  font-weight: 300;
  color: #111111;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/JobAspects/JobAspects.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF","sourcesContent":[".title {\r\n  padding: 16px 24px;\r\n  font-size: 20px;\r\n  font-weight: 300;\r\n  color: #111111;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `JobAspects_title__NWhVl`
};
export default ___CSS_LOADER_EXPORT___;
